export default __webpack_public_path__ + "assets/048b147b331e6ef0de6fdfeb90c90ec2.png";